// import React from 'react';
import { render } from '@testing-library/react';
import React, { useState, useEffect, PureComponent, useRef, useMemo, useCallback, Fragment } from 'react';
// import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { NavLink } from 'react-router-dom';
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  LineChart,
  Line,

  Legend,
  ReferenceLine,
  ResponsiveContainer,
} from 'recharts';
import { PieChart, Pie, Sector, } from "recharts";
import "./EpicfinanceTrends.css";
import * as ReactBootstrap from 'react-bootstrap';
import $ from 'jquery'
import config from '../config';
import Sidebar from '../SideMenu';

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, value, index }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.3;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  const labelarray = ['#ffffff', '#000000', '#000000', '#000000', '#1A1549', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff'];
  if (value > 5) {
    const colors = labelarray[index]
    return (

      <text x={x} y={y} fill={colors} className="text-size-a" textAnchor={x > cx ? 'start' : 'end'} >

        {`${(value).toFixed(1)}%`}
      </text>
    )
  };
};
const renderCustomized12LabelFixed = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, value, index, name }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.4;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  const labelarray = ['#ffffff', '#ffffff', '#000000', '#ffffff', '#ffffff', '#ffffff', '#ffffff', '#000000'];
  if (value > 5) {
    //console.log(index);
    const colors = labelarray[index]
    //console.log("value");
    return (

      <text x={x} y={y} fill={colors} className="text-size-a-wealth" textAnchor={x > cx ? 'start' : 'end'} >

        {`${(value).toFixed(1)}%`}
      </text>
    )
  };
};

const DONUTCOLORS10 = ['#1A1549', '#9DB1DB', '#E6EEF6', '#A6A6A6', '#DCDCDC', '#99103B', '#B85876', '#D296A9', '#1A1549', '#9DB1DB', '#E6EEF6', '#A6A6A6', '#DCDCDC', '#99103B', '#B85876', '#D296A9']

const DONUTCOLORSNew = ['#1A1549', '#9DB1DB', '#99103B', '#DCDCDC', '#A6A6A6'];
const DONUTCOLORS8 = ['#1A1549', '#99103b']

const renderColorfulLegendText = (value, entry) => {
  const { color } = entry;
  return <span className="legend-span">{value + '  ' + (entry.payload.value).toFixed(1) + '%'}</span>;
};

const renderColorfulLegendTextMarketcap = (value, entry) => {
  const { color } = entry;
  return <span className="legend-span">{value + ',  ' + (entry.payload.value).toFixed(1) + '%'}</span>;
};

const renderColor12fulLegendText = (value, entry) => {
  const { color } = entry;
  //console.log(value, entry.payload.value);

  return <span className="legend-span">{value + ' ' + (entry.payload.value) + '%'}</span>;
};


const EpicMultiAssetBalancedFunction = () => {
  const [productscommulativePerformance, setproductscommulativePerformance] = useState([]);
  const [productscommulativePerformanceB, setproductscommulativePerformanceB] = useState([]);
  const [twelvemonPerfAGBP, settwelvemonPerfAGBP] = useState([]);
  const [twelvemonPerfBGBP, settwelvemonPerfBGBP] = useState([]);
  const [monthlyPerformance2DArrayState, setmonthlyPerformance2DArrayState] = useState([]);
  const [monthsArrayState, setmonthsArrayState] = useState([]);

  const [InceptionArrayState, setInceptionArrayState] = useState([]);


  const [AssetAllocation, setAssetAllocation] = useState([]);
  const [SessionResponse, setSessionResponse] = useState([]);

  const [top3response, settop3response] = useState([]);
  const [bot3response, setbot3response] = useState([]);

  const [InceptionData, setInceptionData] = useState([]);

  const [HeadingState, setHeadingState] = useState([]);
  const [ObjectiveState, setObjectiveState] = useState([]);
  const [TeamState, setTeamState] = useState([]);
  const [Summary, setSummary] = useState([]);

  const [Literature, setLiterature] = useState([]);
  const [FundNameState, setFundNameState] = useState([]);
  const [LiteratureDataState, setLiteratureDataState] = useState([]);
  const [LiteratureSummaryDataState, setLiteratureSummaryDataState] = useState([]);
  const [KeyInveInfoState, setKeyInveInfoState] = useState([]);
  const [PressCoverageState, setPressCoverageState] = useState([]);
  const [ApplicationsState, setApplicationsState] = useState([]);
  const [ReportsState, setReportsState] = useState([]);
  const [offerDocumentState, setofferDocumentState] = useState([]);

  const [productsCommentary, setproductsCommentary] = useState([]);
  const [productsFundinfo, setproductsFundinfo] = useState([]);
  const [CMSFundinfo, setCMSFundinfo] = useState([]);
  const [CMSshareinfo, setCMSshareinfo] = useState([]);
  const [productsShareClass, setproductsShareClass] = useState([]);
  const [productsMonthlyPerf, setproductsMonthlyPerf] = useState([]);
  const [portfolioStatus, setportfolioStatus] = useState(false);

  const [graphData, setgraphData] = useState([]);
  const [InceptionArrayState2, setInceptionArrayState2] = useState([]);

  const [top10HoldingState, settop10HoldingState] = useState([]);


  const [marketCapState, setmarketCapState] = useState([]);
  const [equititeState, setequititeState] = useState([]);

  const [DerVarState, setDerVarState] = useState([]);
  const [PRTU, setPRTU] = useState([]);
  const [arrPRTUState, setarrPRTUState] = useState([]);
  const [PRTUDate, setPRTUDate] = useState([]);
  const [StateSession, setStateSession] = useState([]);



  const [regionBreakdownState, setregionBreakdownState] = useState([]);

  const [sectorBreakdownState, setsectorBreakdownState] = useState([]);






  const [graphDataVAR, setgraphDataVAR] = useState([]);
  const [graphDataSectorPer, setgraphDataSectorPer] = useState([]);


  const [cummulatovePerfData, setcummulatovePerfData] = useState([]);
  const [cummulatovePerfBData, setcummulatovePerfBData] = useState([]);


  const [TwelveMperfAGBPState, setTwelveMperfAGBPState] = useState([]);



  const [top3contriState, settop3contriState] = useState([]);

  const [bot3contriarray, setbot3contriarray] = useState([]);
  const [Fundinfoarray, setFundinfoarray] = useState([]);
  const [ShareClassarray, setShareClassarray] = useState([]);
  const [CMSFundinfoarray, setCMSFundinfoarray] = useState([]);
  const [CMSshareinfoarray, setCMSshareinfoarray] = useState([]);

  const [Loading, setLoading] = useState(false);

  const [productRegional, setproductRegional] = useState([]);
  const [productstop10Holding, setproductstop10Holding] = useState([]);
  const [productsmarketCap, setproductsmarketCap] = useState([]);
  const [productSectorBreakdown, setproductSectorBreakdown] = useState([]);


  const [productRegionBreakdown, setproductRegionBreakdown] = useState([]);


  const [status, setstatus] = useState(false);


  useEffect(() => {

    fetchMyAPI()

  }, [])
  const Clicked = () => {
    $("#literatureTab").click();
    literatureButton();
    //console.log("clicked")
  }

  const literatureButton = () => {

    let FundName;

    let LiteratureName;
    let FileName;
    let LiteratureDate;
    let LiteratureTitle;
    let FinancialTrendFund;
    let OtherInfoLiteratureArr = [];
    let OtherSummaryInfoLiteratureArr = [];
    let KeyInveInfoLiteratureArr = [];
    let pressCoverageLiteratureArr = [];
    let applicationsLiteratureArr = [];
    let reportsLiteratureArr = [];
    let offerDocumentsLiteratureArr = [];

    var LiteratureKeys = ["LiteratureNameKey", "FileName", "LiteratureDate", "LiteratureTitle"];

    for (let i = 0; i < Literature.length; i++) {
      let OtherInfoObj = {};
      let KeyInveInfoObj = {};
      let pressCoverageObj = {};
      let applicationsObj = {};
      let reportsObj = {};
      let offerDocumentsObj = {};




      FundName = Literature[i].fund_name;

    //  console.log("FundName : " + FundName );
      //console.log(Literature[i] );

      if (FundName == "aim_portfolio") {
        //console.log(FundName)

        if (Literature[i].literature_name == "other_information") {

          FinancialTrendFund = FundName;
          LiteratureTitle = Literature[i].title;
          LiteratureName = Literature[i].literature_name;
          FileName = Literature[i].file;
          LiteratureDate = Literature[i].date;

          OtherInfoObj[LiteratureKeys[0]] = LiteratureName;
          OtherInfoObj[LiteratureKeys[1]] = FileName;
          OtherInfoObj[LiteratureKeys[2]] = LiteratureDate;
          OtherInfoObj[LiteratureKeys[3]] = LiteratureTitle;

          OtherInfoLiteratureArr.push(OtherInfoObj);
        }
        if (Literature[i].literature_name == "other_information_summary") {

          FinancialTrendFund = FundName;
          LiteratureTitle = Literature[i].title;
          LiteratureName = Literature[i].literature_name;
          FileName = Literature[i].file;
          LiteratureDate = Literature[i].date;

          OtherInfoObj[LiteratureKeys[0]] = LiteratureName;
          OtherInfoObj[LiteratureKeys[1]] = FileName;
          OtherInfoObj[LiteratureKeys[2]] = LiteratureDate;
          OtherInfoObj[LiteratureKeys[3]] = LiteratureTitle;

          OtherSummaryInfoLiteratureArr.push(OtherInfoObj);
        }
        if (Literature[i].literature_name == "key_investor_information") {

          FinancialTrendFund = FundName;
          LiteratureTitle = Literature[i].title;
          LiteratureName = Literature[i].literature_name;
          FileName = Literature[i].file;
          LiteratureDate = Literature[i].date;

          KeyInveInfoObj[LiteratureKeys[0]] = LiteratureName;
          KeyInveInfoObj[LiteratureKeys[1]] = FileName;
          KeyInveInfoObj[LiteratureKeys[2]] = LiteratureDate;
          KeyInveInfoObj[LiteratureKeys[3]] = LiteratureTitle;

          KeyInveInfoLiteratureArr.push(KeyInveInfoObj);

        }
        if (Literature[i].literature_name == "press_Coverage") {

          FinancialTrendFund = FundName;
          LiteratureTitle = Literature[i].title;
          LiteratureName = Literature[i].literature_name;
          FileName = Literature[i].file;
          LiteratureDate = Literature[i].date;

          pressCoverageObj[LiteratureKeys[0]] = LiteratureName;
          pressCoverageObj[LiteratureKeys[1]] = FileName;
          pressCoverageObj[LiteratureKeys[2]] = LiteratureDate;
          pressCoverageObj[LiteratureKeys[3]] = LiteratureTitle;

          pressCoverageLiteratureArr.push(pressCoverageObj);

        }
        if (Literature[i].literature_name == "applications") {

          FinancialTrendFund = FundName;
          LiteratureTitle = Literature[i].title;
          LiteratureName = Literature[i].literature_name;
          FileName = Literature[i].file;
          LiteratureDate = Literature[i].date;

          applicationsObj[LiteratureKeys[0]] = LiteratureName;
          applicationsObj[LiteratureKeys[1]] = FileName;
          applicationsObj[LiteratureKeys[2]] = LiteratureDate;
          applicationsObj[LiteratureKeys[3]] = LiteratureTitle;

          applicationsLiteratureArr.push(applicationsObj);

        }
        if (Literature[i].literature_name == "reports") {

          FinancialTrendFund = FundName;
          LiteratureTitle = Literature[i].title;
          LiteratureName = Literature[i].literature_name;
          FileName = Literature[i].file;
          LiteratureDate = Literature[i].date;

          reportsObj[LiteratureKeys[0]] = LiteratureName;
          reportsObj[LiteratureKeys[1]] = FileName;
          reportsObj[LiteratureKeys[2]] = LiteratureDate;
          reportsObj[LiteratureKeys[3]] = LiteratureTitle;

          reportsLiteratureArr.push(reportsObj);

        }
        if (Literature[i].literature_name == "offering_documents") {

          FinancialTrendFund = FundName;
          LiteratureTitle = Literature[i].title;
          LiteratureName = Literature[i].literature_name;
          FileName = Literature[i].file;
          LiteratureDate = Literature[i].date;

          offerDocumentsObj[LiteratureKeys[0]] = LiteratureName;
          offerDocumentsObj[LiteratureKeys[1]] = FileName;
          offerDocumentsObj[LiteratureKeys[2]] = LiteratureDate;
          offerDocumentsObj[LiteratureKeys[3]] = LiteratureTitle;

          offerDocumentsLiteratureArr.push(offerDocumentsObj);

        }


      }

    }
    setFundNameState(FinancialTrendFund);
    setLiteratureDataState(OtherInfoLiteratureArr);
    setLiteratureSummaryDataState(OtherSummaryInfoLiteratureArr);
    setKeyInveInfoState(KeyInveInfoLiteratureArr);
    setPressCoverageState(pressCoverageLiteratureArr);
    setApplicationsState(applicationsLiteratureArr);
    setReportsState(reportsLiteratureArr);
    setofferDocumentState(offerDocumentsLiteratureArr);

  }
  const tt = () => {
    $('.btn-setting')[0].click();
  }
  const summaryButton = () => {

    let arrPRTU = []
    var heading;
    var objective;
    var team;
    for (let i = 0; i < Summary.length; i++) {
      // typeof(products[i][j])
      if (Summary[i].heading == "aim_portfolio") {
        heading = Summary[i].heading;
        objective = Summary[i].objective_content;
        team = Summary[i].team_content;
      }

    }
    // For loop for calculation date
    let calculation = PRTU[1][2]
    // new Date(date).toLocaleDateString()


    let calculatedDate = new Date(calculation).toLocaleDateString("en-US", { day: 'numeric' }) + "/" + new Date(calculation).toLocaleDateString("en-US", { month: 'numeric' }) + "/" + new Date(calculation).toLocaleDateString("en-US", { year: 'numeric' });


    setarrPRTUState(arrPRTU)
    setPRTUDate(calculatedDate)
    setHeadingState(heading)
    setObjectiveState(objective)
    setTeamState(team)
    setStateSession(SessionResponse);
    $('.footer-container').addClass('footer-container-line')
    literatureButton();
  }


  const portfolioButton = () => {

    const graphDataResponse = []
    const graphDataResponse1 = []
    const graphDataResponse2 = []

    const top10HoldingData = []
    const marketCapData = []
    const equitiesData = []
    const DerVarData = []

    const sectorBreakdownData = []
    const RegionbreakdownArray = []
    const sectorbreakdownArray = []
    const InceptionDataArray2 = []

    var keysVAR = ["name", "value"]
    var length = AssetAllocation.length;
    for (let i = 1; i < length; i++) {

      let obj = {};
      for (let j = 0; j < AssetAllocation[i].length; j++) {

        if (!isNaN(AssetAllocation[i][j])) {
          let val = AssetAllocation[i][j] * 100;

          var rounded1 = Math.round((val + Number.EPSILON) * 100) / 100;

          //console.log(rounded1);
          obj[keysVAR[j]] = rounded1;

        }
        else {

          obj[keysVAR[j]] = AssetAllocation[i][j];
        }

      }
      if (obj.value !== 0) {

        graphDataResponse1.push(obj)
      }
    }




    var keystop10Hold = ["name", "sector", "market_cap", "value"]

    for (let i = 1; i < 11; i++) {
      // typeof(products[i][j])

      let obj = {};
      for (let j = 0; j < productstop10Holding[i].length; j++) {
        if (!isNaN(productstop10Holding[i][j])) {
          let val = productstop10Holding[i][j] * 100;
          var rounded = Math.round((val + Number.EPSILON) * 100) / 100;
          obj[keystop10Hold[j]] = rounded + " %";
        } else {
          obj[keystop10Hold[j]] = productstop10Holding[i][j];
        }
      }
      top10HoldingData.push(obj)
    }

    var keysInceptionData21 = ["name", "value"]
    var length = productstop10Holding.length;
    let obj1 = {};
    let obj2 = {};
    let obj = {};
    obj1[keysInceptionData21[0]] = productstop10Holding[1][5];
    let val12 = productstop10Holding[1][6] * 100;
    var rounded112 = Math.round(Math.round((val12 + Number.EPSILON) * 100) / 100, 1);
    obj1[keysInceptionData21[1]] = rounded112;
    obj2[keysInceptionData21[0]] = productstop10Holding[2][5];
    let val123 = productstop10Holding[2][6] * 100;
    var rounded1123 = Math.round(Math.round((val123 + Number.EPSILON) * 100) / 100, 1);
    obj2[keysInceptionData21[1]] = rounded1123;
    obj = [obj1, obj2]
    let objlength = obj.length
    for (let i = 0; i < objlength; i++) {
      if (obj[i].value !== 0) {
        InceptionDataArray2.push(obj[i])
      }
    }


    /**
     * Market Cap data from factsheet excel and return path of chart image.
     *
     * return array data according chart
     */

    // function marketCapFunction(index) {
    //   var keysMarketCap = ["name", "value"];
    //   let obj = {};
    //   if (productsmarketCap[index] != 0) {
    //     obj[keysMarketCap[0]] = index;
    //     obj[keysMarketCap[1]] = productsmarketCap[index];
    //     marketCapData.push(obj)
    //   }
    // }
    // Object.keys(productsmarketCap).forEach(marketCapFunction);

    var keysMarketCap = ["name", "value"]
    var length = productsmarketCap.length;
    for (let i = 1; i < length; i++) {

      let obj = {};
      for (let j = 0; j < productsmarketCap[i].length; j++) {

        if (!isNaN(productsmarketCap[i][j])) {
          let val = productsmarketCap[i][j] * 100;

          var rounded1 = Math.round((val + Number.EPSILON) * 100) / 100;

         // console.log(rounded1);
          obj[keysMarketCap[j]] = rounded1;

        }
        else {

          obj[keysMarketCap[j]] = productsmarketCap[i][j];
        }

      }
      if (obj.value !== 0) {

        marketCapData.push(obj)
      }
    }

    /*  Market Cap Chart data */

    var keysSectorBreakdown = ["name", "value"]
    var length = productSectorBreakdown.length;
    for (let i = 1; i < length; i++) {
      let obj = {};
      for (let j = 0; j < productSectorBreakdown[i].length; j++) {

        if (!isNaN(productSectorBreakdown[i][j])) {
          let val = productSectorBreakdown[i][j] * 100;
          var rounded = Math.round((val + Number.EPSILON) * 100) / 100;
          obj[keysSectorBreakdown[j]] = rounded;

        }
        else {
          obj[keysSectorBreakdown[j]] = productSectorBreakdown[i][j];
        }

      }
      if (obj.value !== 0) {

        equitiesData.push(obj)

      }

    }

    var keysRegionBreakdown = ["name", "value"]

    for (let i = 1; i < productRegionBreakdown; i++) {

      let obj = {};
      for (let j = 0; j < productRegionBreakdown[i].length; j++) {

        if (!isNaN(productRegionBreakdown[i][j])) {
          let val = productRegionBreakdown[i][j] * 100;

          var rounded = Math.round((val + Number.EPSILON) * 100) / 100;

          
          obj[keysRegionBreakdown[j]] = rounded;

        }else {
          obj[keysRegionBreakdown[j]] = productRegionBreakdown[i][j];
        }

      }
      graphDataResponse2.push(obj)
    }

    setgraphData(graphDataResponse1)
    setInceptionArrayState2(InceptionDataArray2)
    settop10HoldingState(top10HoldingData)
    setmarketCapState(marketCapData)
    setequititeState(equitiesData)
    setDerVarState(DerVarData)
    setregionBreakdownState(RegionbreakdownArray)
    setsectorBreakdownState(sectorbreakdownArray)
    setgraphDataSectorPer(graphDataResponse2)
    setportfolioStatus(true)
  }




  const performanceButton = () => {


    const CummulativeperformanceData = []
    const CummulativeperformanceBData = []

    const TwelveMperfAGBP = []


    const Bot3contriData = []
    const Top3contriData = []
    const InceptionDataArray = []
    var monthsArr = [];

   // console.log("months")
   // console.log(monthsArr)

    var arr2D = [];

    for (let i = 0; i < arr2D.length; i++) {
      for (let j = 0; j < arr2D[0].length; j++) {
        if (arr2D[i][j] == 0 + '%') {
        //  console.log(arr2D[i][j])
          arr2D[i][j] = "0.00%"
        } else if (arr2D[i][j] == '') {
          arr2D[i][j] = ""
        }
      //  console.log(arr2D[i][j])
      }
    }

    var keysInceptionData = ["date", "value"]
    for (let i = 1; i < InceptionData.length; i++) {
      let obj = {};
      var date = InceptionData[i][0]
      var PerformanceValue = InceptionData[i][4]
      var AlphaDate = new Date(date).toLocaleDateString("en-US", { month: 'short' }) + "-" + new Date(date).toLocaleDateString("en-US", { year: 'numeric' })
      obj[keysInceptionData[0]] = AlphaDate;
      obj[keysInceptionData[1]] = PerformanceValue * 100;
      InceptionDataArray.push(obj)

      date = null
      PerformanceValue = null
    }
    setInceptionArrayState(InceptionDataArray)


    var keysCummulativePer = ["name", "value"]

    for (let i = 0; i < productscommulativePerformance.length; i++) {
      let obj = {};
      for (let j = 0; j < productscommulativePerformance[i].length; j++) {

        if (!isNaN(productscommulativePerformance[i][j])) {
          let val = productscommulativePerformance[i][j] * 100;

          // var numb= 212421434.533423131231;
          var rounded = Math.round((val + Number.EPSILON) * 1000) / 1000;
          rounded = parseFloat(rounded).toFixed(2);
          
          obj[keysCummulativePer[j]] = rounded + '%';

        }
        else {
          obj[keysCummulativePer[j]] = productscommulativePerformance[i][j];
        }

      }
      CummulativeperformanceData.push(obj)
    }


    var keys12monthsDis = ["name", "value"]
    for (let i = 0; i < twelvemonPerfAGBP.length; i++) {
      let obj = {};
      for (let j = 0; j < twelvemonPerfAGBP[i].length; j++) {

        if (!isNaN(twelvemonPerfAGBP[i][j])) {
          let val = twelvemonPerfAGBP[i][j] * 100;

          // var numb= 212421434.533423131231;
          var rounded = Math.round((val + Number.EPSILON) * 1000) / 1000;
          rounded = parseFloat(rounded).toFixed(2);
          
          obj[keys12monthsDis[j]] = rounded + '%';

        }
        else {
          obj[keys12monthsDis[j]] = twelvemonPerfAGBP[i][j];
        }

      }

      TwelveMperfAGBP.push(obj)



    }

    var keystop3contr = ["name", "value"]

    for (let i = 1; i < top3response.length; i++) {
      // typeof(products[i][j])

      let obj = {};
      for (let j = 0; j < top3response[i].length; j++) {

        if (!isNaN(top3response[i][j])) {
          let val = top3response[i][j] * 100;

          // var numb= 212421434.533423131231;
          var rounded = Math.round((val + Number.EPSILON) * 100) / 100;

          
          obj[keystop3contr[j]] = rounded;

        }

        // var updatedVal =  parseFloat(val).toFixed(2);
        // console.log(updatedVal);
        else {
          obj[keystop3contr[j]] = top3response[i][j];
        }

      }

      Top3contriData.push(obj)


      // console.log("allKeys")

    }

    var keysbot3contr = ["name", "value"]

    for (let i = 1; i < bot3response.length; i++) {
      // typeof(products[i][j])

      let obj = {};
      for (let j = 0; j < bot3response[i].length; j++) {

        if (!isNaN(bot3response[i][j])) {
          let val = bot3response[i][j] * 100;

          // var numb= 212421434.533423131231;
          var rounded = Math.round((val + Number.EPSILON) * 100) / 100;

          
          obj[keysbot3contr[j]] = rounded;

        }

        // var updatedVal =  parseFloat(val).toFixed(2);
        // console.log(updatedVal);
        else {
          obj[keysbot3contr[j]] = bot3response[i][j];
        }

      }

      Bot3contriData.push(obj)


      // console.log("allKeys")

    }


    setcummulatovePerfData(CummulativeperformanceData)
    setcummulatovePerfBData(CummulativeperformanceBData)
    //   setCummulativeperfeBEURData(CummulativeperformanceBEURData)

    //   setCummulativeperfC(CummulativeperformanceCData)

    setTwelveMperfAGBPState(TwelveMperfAGBP)
    settop3contriState(Top3contriData)
    setbot3contriarray(Bot3contriData)
    setmonthlyPerformance2DArrayState(arr2D)
    setmonthsArrayState(monthsArr)
    // console.log(monthlyPerformance2DArrayState);
    // console.log("monthlyPerformance2DArrayState");





  }


  const informationButton = () => {
    const shareClassData = []
    const fundInfoData = []
    const CMSfundInfoData = []
    const CMSshareInfoData = []

    var keysCMSshareinfo = ["name", "ausdValue", "agbpValue", "aeurValue", "busdValue", "bgbpValue", "beurValue"]

    for (let j = 0; j < CMSshareinfo.length; j++) {

      let obj = {};

      obj[keysCMSshareinfo[0]] = CMSshareinfo[j].title;
      obj[keysCMSshareinfo[1]] = CMSshareinfo[j].ausd_value;
      obj[keysCMSshareinfo[2]] = CMSshareinfo[j].agbp_value;
      obj[keysCMSshareinfo[3]] = CMSshareinfo[j].aeur_value;
      obj[keysCMSshareinfo[4]] = CMSshareinfo[j].busd_value;
      obj[keysCMSshareinfo[5]] = CMSshareinfo[j].bgbp_value;
      obj[keysCMSshareinfo[6]] = CMSshareinfo[j].beur_value;


      CMSshareInfoData.push(obj)
    }

    var keysCMSFundinfo = ["name", "value"]

    for (let j = 0; j < CMSFundinfo.length; j++) {
      // console.log(CMSFundinfo[j].title);
      // console.log("CMSFundinfo.title");

      let obj = {};

      // KeyInveInfoObj[LiteratureKeys[0]] = LiteratureName;

      obj[keysCMSFundinfo[0]] = CMSFundinfo[j].title;
      obj[keysCMSFundinfo[1]] = CMSFundinfo[j].value;


      CMSfundInfoData.push(obj)
    }

    var keysShareClass = ["name", "value"]

    for (let i = 0; i < productsShareClass.length; i++) {
      // typeof(products[i][j])

      let obj = {};
      for (let j = 0; j < productsShareClass[i].length; j++) {

        if (!isNaN(productsShareClass[i][j])) {
          let val = productsShareClass[i][j];

          // var numb= 212421434.533423131231;
          var rounded = Math.round((val + Number.EPSILON) * 100) / 100;

          
          obj[keysShareClass[j]] = rounded.toString().replace(/(^\d{1,3}|\d{3})(?=(?:\d{3})+(?:$|\.))/g, '$1,') + 'p';
          // console.log(obj);
          // console.log("obj");
        }

        
        else {
          obj[keysShareClass[j]] = productsShareClass[i][j];
        }

      }
      shareClassData.push(obj)


    }


    var keysFundinfo = ["name", "value"]

    for (let i = 1; i < productsFundinfo.length; i++) {
      // typeof(products[i][j])

      let obj = {};
      for (let j = 0; j < productsFundinfo[i].length; j++) {

        if (!isNaN(productsFundinfo[i][j])) {
          let val = productsFundinfo[i][j] * 100;

          // var numb= 212421434.533423131231;
          var rounded = Math.round((val + Number.EPSILON) * 100) / 100;
          var mrounded = Math.round((productsFundinfo[i][j] + Number.EPSILON) * 100) / 100;
          obj[keysFundinfo[j]] = rounded.toString().replace(/(^\d{1,3}|\d{3})(?=(?:\d{3})+(?:$|\.))/g, '$1,');
          if (mrounded > 1000000) {
            var million_variable = (mrounded / 1000000).toFixed(2) + 'M'

            obj[keysFundinfo[j]] = '£ ' + million_variable;

          }
        } else {
          obj[keysFundinfo[j]] = productsFundinfo[i][j];
        }

      }
      fundInfoData.push(obj)


    }

    setShareClassarray(shareClassData)
    setFundinfoarray(fundInfoData)
    setCMSFundinfoarray(CMSfundInfoData)
    setCMSshareinfoarray(CMSshareInfoData)
  }









  let AbcObject = {};

  let count = 0;
  async function fetchMyAPI() {
    const Localurl = 'https://www.epicip.com/vtepic-multi-asset-balanced-fund'
    const Local2url = 'https://www.epicip.com/vtepic-multi-asset-balanced-fund'
    const url = config.apiPath +'/AIM-Portfolio' 
    //const url = 'http://127.0.0.1:8000/AIM-Portfolio'

    fetch(config.apiPath + '/session_data').then(resp => resp.json()).then(resp => {
      // console.log(resp);
      // console.log("resp");

      setSessionResponse(resp);


    })
    fetch(url).then(resp => resp.json())
      .then(resp => {

        setAssetAllocation(resp.Assetsallocation)
        setproductscommulativePerformance(resp.CumulativePerf)
        setInceptionData(resp.inceptionperfdata)

        setproductscommulativePerformanceB(resp.Cumulativeclassflnc)

        settwelvemonPerfAGBP(resp.twelvemPerfDiscrete)
        settwelvemonPerfBGBP(resp.twelvemPerfDiscreteclassflnc)
        settop3response(resp.Top3Contributors)
        setbot3response(resp.Bottom3Contributors)

        setproductsCommentary(resp.content)
        setproductRegional(resp.RegionalWeightings)
        setproductstop10Holding(resp.TopHoldings)

        setproductsmarketCap(resp.MarketCapBreakdown)

        setproductsFundinfo(resp.FundInfo)
        setproductsShareClass(resp.NAVperShare)

        setproductsMonthlyPerf(resp.MonthlyPerf)
        // setLoading(true)
        setPRTU(resp.prtu)
        setLiterature(resp.literature)
        setSummary(resp.summary)
        setCMSFundinfo(resp.fund_info)
        setCMSshareinfo(resp.shareinfo)

        // setLoading(true)
        setstatus(true)
        document.getElementById("summaryButton").click();

      })

      .catch(e => {
        // console.log(e);
      })
  };


  if ($(".accordion__item__header").length > 0) {

    var active = "active";
    var activedis = "active-dis";
    $(".accordion__item__header").on("click", function (event) {
      event.stopImmediatePropagation();
      $(this).toggleClass(active);
      $(this).find(".navlink").toggleClass(activedis);

      $(this).next("div").slideToggle(200);
    });
  }

  //use in future
  function renderDailyPrices(DailyPrice, index) {
    if (DailyPrice.Price !== 0) {
      return (
        <div class="DailyPricing__DailyPriceCard-sc-62f3gi-1 coIgZR">
          <div class="DailyPricing__DailyPrice-sc-62f3gi-2 gsZde">${DailyPrice.Price}</div>
          <div class="DailyPricing__DailyPriceName-sc-62f3gi-3 iLShEo">Class A<br /><span className="daily-span">(USD) Shares</span></div>
        </div>
      )
    }
  }

  function renderLiteratureData(data, index) {
    return (

      <div class="col-sm-6">
        <p class="pdf_download"><a href={config.apiPath + "/storage/literature-file/" + data.FileName} download target="_blank">{data.LiteratureTitle}<br /><span class="date">{data.LiteratureDate}</span></a></p>
      </div>
    )
  }

  function renderLiteratureDataPO(data, index) {
    if (data.LiteratureNameKey == "other_information_summary") {
      return (
        <div class="col-sm-12" style={{ paddingLeft: "0px", paddingRight: "0px" }}>
          <p class="pdf_download"><a href={config.apiPath + "/storage/literature-file/" + data.FileName} target="_blank" download>{data.LiteratureTitle}</a></p>
        </div>
      )
    }

  }
  function renderLiteratureDataRecent(data, index, sumCount) {
    if (index <= 1) {
      return (

        <div class="col-sm-6">
          <p class="pdf_download"><a href={config.apiPath + "/storage/literature-file/" + data.FileName} target="_blank" download>{data.LiteratureTitle}<br /><span class="date">{data.LiteratureDate}</span></a></p>
        </div>
      )
    }
  }
  function renderTop10Holding(holding, index) {
    return (
      <tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ eVXooJ_new" key={index}>
        <td className="align-left">{holding.name}</td>
        <td className="align-left">{holding.sector}</td>
        <td className="align-left">{holding.market_cap}</td>
        <td className="align-right">{holding.value}</td>
      </tr>


    )
  }

  // use in future
  const CustomizedAxisTick = ({ x, y, stroke, payload }) => {

    return (
      <g transform={`translate(${x},${y})`}>
        <text x={60} y={0} dy={16} textAnchor="end" fill="#666" transform="rotate(-10)">
          {payload.value}
        </text>
      </g>
    );
  };


  // productscommulativePerformance
  function renderCummulativePerformanceNames(cummulatove, index) {
    if (index == 0) {
      return (
        <th>{cummulatove.value}</th>
      )
    } else {
      return (
        <th>{cummulatove.name}</th>
      )
    }
  }

  function renderCummulativePerformanceValue(cummulatove, index) {
    if (index == 0) {
      return (
        <td>{cummulatove.name}</td>
      )
    } else {
      return (
        <td>{cummulatove.value}</td>
      )
    }
  }

  // Use in future
  // function rendertop3contri(top3contriparam, index){
  //   return(
  //     <tr className="AssetClass__Row-sc-1rmhbx4-5 eVXooJ" key={index}>
  //       <td className="align-left">{top3contriparam.name}</td>
  //       <td className="align-right">{top3contriparam.value}</td>
  //     </tr>
  //   )
  // }

  // Use in future

  // function renderMonthNames(months, index){
  //     return(

  //       <th>{months}</th>
  //   )
  //   }


  function renderCMSshareinfo(shareinfoparam, index) {
    // alert(bot3contriparam.name);
    if (index == 3 || index == 2) {
      return (
        <tr className="Shares__Row-sc-1brks4f-2 eoQrEv" key={index}>

          <td className="align-left">{shareinfoparam.name}</td>
          {shareinfoparam.ausdValue ?
            <td className="align-center" colspan="6">{shareinfoparam.ausdValue}</td> : ""}
          {shareinfoparam.agbpValue ?
            <td className="align-center">{shareinfoparam.agbpValue}</td> : ""}
          {shareinfoparam.aeurValue ?
            <td className="align-center">{shareinfoparam.aeurValue}</td> : ""}
          {shareinfoparam.busdValue ?
            <td className="align-center">{shareinfoparam.busdValue}</td> : ""}
          {shareinfoparam.bgbpValue ?
            <td className="align-center">{shareinfoparam.bgbpValue}</td> : ""}
          {shareinfoparam.beurValue ?
            <td className="align-center">{shareinfoparam.beurValue}</td> : ""}

        </tr>
      )
    } else {
      return (
        <tr className="Shares__Row-sc-1brks4f-2 eoQrEv" key={index}>

          <td className="align-left">{shareinfoparam.name}</td>
          <td className="align-center">{shareinfoparam.ausdValue}</td>
          <td className="align-center">{shareinfoparam.agbpValue}</td>
          <td className="align-center">{shareinfoparam.aeurValue}</td>
          <td className="align-center">{shareinfoparam.busdValue}</td>
          <td className="align-center">{shareinfoparam.bgbpValue}</td>
          <td className="align-center">{shareinfoparam.beurValue}</td>

        </tr>
      )
    }
  }


  function renderFundinfo(fundinfoparam, index) {

    return (
      <tr className="FundInformation__Row-sc-18irt95-2 fweCQL" key={index}>

        <td className="align-left">{fundinfoparam.name}</td>
        <td className="align-center">{fundinfoparam.value}</td>
      </tr>
    )
  }
  function renderShareClassNames(shareClass, index) {
    if (index == 0) {

      return (
        <th className="align-left">{shareClass.name}</th>
      )
    } else {
      return (
        <th className="align-center">{shareClass.name}</th>
      )
    }
  }
  function renderShareClassValue(shareClassValue, index) {
    if (index == 0) {
      return (
        <td className="align-left">{shareClassValue.value}</td>
      )
    } else {
      return (
        <td className="align-center">{shareClassValue.value}</td>
      )
    }
  }

  // Use in future


  // var valEquCounts = 0;
  // var indexEquKey = 0;
  // var newEqucolor ="#353637";
  // var newEquKeycolor ="#1A1549";
  // function equitichart(entry, index){
  //   if(entry.name==="Cash & Other"){
  //     newEqucolor = grayarray[valEquCounts];
  //     valEquCounts = Number(valEquCounts) + Number(1);
  //     return (
  //       <Cell key={`cell-${index}`} fill={newEqucolor} />
  //     )
  //   }else if(entry.name==="Uncorrelated"){
  //     newEqucolor = grayarray[valEquCounts];
  //     valEquCounts = Number(valEquCounts) + Number(1);
  //     return (
  //       <Cell key={`cell-${index}`} fill={newEqucolor} />
  //     )
  //   }else if(entry.name==="Property"){
  //     newEqucolor = grayarray[valEquCounts];
  //     valEquCounts = Number(valEquCounts) + Number(1);
  //     return (
  //       <Cell key={`cell-${index}`} fill={newEqucolor} />
  //     )
  //   }else if(entry.name==="Commodities"){
  //     newEqucolor = grayarray[valEquCounts];
  //     valEquCounts = Number(valEquCounts) + Number(1);
  //     return (
  //       <Cell key={`cell-${index}`} fill={newEqucolor} />
  //     )
  //   }else if(entry.name==="Fixed Income"){
  //     newEqucolor = grayarray[valEquCounts];
  //     valEquCounts = Number(valEquCounts) + Number(1);
  //     return (
  //       <Cell key={`cell-${index}`} fill={newEqucolor} />
  //     )
  //   }else{
  //     newEquKeycolor = DONUTCOLORS10[indexEquKey];
  //     indexEquKey = Number(indexEquKey) + Number(1);
  //   return (
  //       <Cell key={`cell-${index}`} fill={newEquKeycolor} />
  //     )
  //   }
  // }

  var graphDataset = [];
  function assessAllocation(entry, index) {
    // console.log(index, 'mahesh234');
    if (entry.name === "Fixed Income") {
      graphDataset = entry.name;
      document.getElementById("hide_show_fixed").style.display = 'block';
      document.getElementById("hide_show_fixed_text").style.display = 'none';
    } else if (entry.name === "Equities") {
      graphDataset = entry.name;
      document.getElementById("hide_show_equity").style.display = 'block';
      document.getElementById("hide_show_equity_text").style.display = 'none';
    }
  }

  return (
    <Fragment>

      {status === true ?

        <section className="main-box">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-3 col-sm-4">
                <Sidebar StateSession={{StateSession:StateSession,"url":"AIMPortfolioDFM","group":"Equities"}}/>
              </div>
              <div class="col-lg-8 col-md-8 col-sm-8 offset-md-1">
                <ul class="nav nav-tabs custom-nav-tabs" role="tablist">
                  <li class="nav-item nav-item-tabs"> <a class="nav-link active" data-toggle="tab" id="summaryButton" href="#nine" onClick={summaryButton} role="tab">Summary</a> </li>
                  <li class="nav-item nav-item-tabs"> <a class="nav-link" data-toggle="tab" href="#eight" onClick={portfolioButton} role="tab">Portfolio</a> </li>
                  <li class="nav-item nav-item-tabs"> <a class="nav-link" data-toggle="tab" href="#one" onClick={performanceButton} role="tab">Performance</a> </li>

                  <li class="nav-item nav-item-tabs"> <a class="nav-link " data-toggle="tab" href="#two" role="tab">Commentary</a> </li>
                  <li class="nav-item nav-item-tabs"> <a class="nav-link" data-toggle="tab" href="#three" onClick={informationButton} role="tab">Information</a> </li>
                  <li class="nav-item nav-item-tabs"> <a class="nav-link" data-toggle="tab" href="#four" id="literatureTab" onClick={literatureButton} role="tab">Literature</a> </li>
                </ul>
                <div class="tab-content">
                  <div class="tab-pane fade active show" id="nine" role="tabpanel">
                    <div class="row">
                      <div class="col-sm-12">
                        <div role="tabpanel" aria-hidden="false" class="fade tab-pane active show">
                          <div class="row">
                            <div class="col">
                              <div class="Paragraph__ParagraphContainer-sc-2ra4j2-0 gnBxSc">
                                <div>
                                  {LiteratureSummaryDataState.length > 0 ? <div><h3><b>Product Overview</b></h3></div> : ""}
                                  {LiteratureSummaryDataState.length > 0 ? LiteratureSummaryDataState.map(renderLiteratureDataPO) : ""}
                                </div>
                              </div>
                            </div>
                            <div class="col-md-12">
                              {PressCoverageState.length > 0 ? <h3><b>Recent Updates</b></h3> : ""}
                            </div>
                            {PressCoverageState.length > 0 ? PressCoverageState.map(renderLiteratureDataRecent) : ""}
                            <div class="col-md-12"></div>
                            <div class="col">
                              <div class="Paragraph__ParagraphContainer-sc-2ra4j2-0 gnBxSc">
                                <div>
                                  <div class="Paragraph__NormalParagraph-sc-2ra4j2-1 dISjjZ" dangerouslySetInnerHTML={{ __html: ObjectiveState }}></div>
                                </div>
                              </div>
                            </div>
                            <div class="row margin-1">
                              <div class="col">
                                <h3 class="Paragraph__Heading-sc-2ra4j2-2">Investment Team</h3>
                                <p class="Paragraph__Body-sc-2ra4j2-4 gIzxtZ" dangerouslySetInnerHTML={{ __html: TeamState }}></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="eight" role="tabpanel">
                    <div class="row chart-row">
                    {/* Start Top 10 Holdings  chart */}
                      <div class="col-md-6 SECmargin chart-block" style={{ height: "389px" }}>
                        <p class="lse_redirect">Top 10 Holdings (% NAV)</p>
                        <p class="lse_redirect"><a className="display-none" target="_blank" href="transaction-own-share.php">Transaction In Own Share</a></p>
                        <PieChart width={300} height={330} margin={{ top: -60, right: 50, bottom: 5, left: 0 }} >
                          <Pie
                            data={InceptionArrayState2}
                            cx={90}
                            cy={200}
                            innerRadius={45}
                            outerRadius={90}
                            // fill="#0c2340"
                            paddingAngle={0}
                            startAngle={90}
                            endAngle={-330}
                            dataKey="value"
                            labelLine={false}
                            label={renderCustomized12LabelFixed}
                          >
                            {InceptionArrayState2.map((entry, index) => (
                              <Cell key={`cell-${index}`} fill={DONUTCOLORS8[index % DONUTCOLORS8.length]} />
                            ))}
                          </Pie>
                          <Legend margin={{ top: -500, }} className="legend-text" formatter={renderColor12fulLegendText} iconSize={10} width={300} height={50} layout='vertical' />

                          <Tooltip />
                        </PieChart>
                      </div>
                      {/* End Top 10 Holdings  chart */}

                       {/* Start Top 10 data listing */}
                      <div class="col-md-6 table-responsive" style={{ paddingRight: "2px" }}>
                        <table class="AssetClass__Table-sc-1rmhbx4-3 iiGyjE ">
                          <tbody class="AssetClass__Body-sc-1rmhbx4-4 cyhKrw">
                            <tr class="AssetClass__Row-sc-1rmhbx4-5 eVXooJ eVXooJ_new">
                              <th className="align-left">Company</th>
                              <th className="align-left">Sector</th>
                              <th className="align-left">Market Cap (£m)</th>
                              <th className="align-right">Weighting</th>
                            </tr>
                            {top10HoldingState.map(renderTop10Holding)}
                          </tbody>
                        </table>
                      </div>

                       {/* End Top 10 data listing */}
                    </div>
                    <div class="row chart-row">

                      {/* Start Market Cap Breakdown Chart */}

                      <div class="col-md-6 VARmargin chart-block" style={{ height: "389px" }}>
                        <p class="lse_redirect">Market Cap Breakdown (% NAV)</p>
                        <p class="lse_redirect"><a className="display-none" target="_blank" href="transaction-own-share.php">Transaction In Own Share</a></p>
                        <PieChart width={300} height={330} margin={{ top: -60, right: 50, bottom: 5, left: 10 }} >
                          <Pie
                            data={marketCapState}
                            cx={80}
                            cy={200}
                            innerRadius={45}
                            outerRadius={90}
                            // fill="#0c2340"
                            paddingAngle={0}
                            startAngle={90}
                            endAngle={-330}
                            dataKey="value"
                            labelLine={false}
                            label={renderCustomizedLabel}
                          >
                            {marketCapState.map((entry, index) => (
                              <Cell key={`cell-${index}`} fill={DONUTCOLORSNew[index % DONUTCOLORSNew.length]} />
                            ))}
                          </Pie>
                          <Legend margin={{ top: -500, }} formatter={renderColorfulLegendTextMarketcap} className="legend-text" iconSize={10} width={300} height={50} layout='vertical' />
                          <Tooltip />
                        </PieChart>
                      </div>
                      {/* End Market Cap Breakdown Chart */}

                      {/* Start Sector breakdown Chart */}
                      <div class="col-md-6 VARmargin chart-block" style={{ height: "389px" }}>
                        <p class="lse_redirect">Sector breakdown (% NAV)</p>
                        <p class="lse_redirect"><a className="display-none" target="_blank" href="transaction-own-share.php">Transaction In Own Share</a></p>
                        <PieChart width={300} height={330} margin={{ top: -60, right: 50, bottom: 5, left: 10 }} >
                          <Pie
                            data={graphData}
                            cx={80}
                            cy={200}
                            innerRadius={45}
                            outerRadius={90}
                            // fill="#0c2340"
                            paddingAngle={0}
                            startAngle={90}
                            endAngle={-330}
                            dataKey="value"
                            labelLine={false}
                            label={renderCustomizedLabel}
                          >
                            {graphData.map((entry, index) => (
                              <Cell key={`cell-${index}`} fill={DONUTCOLORS10[index % DONUTCOLORS10.length]} />
                            ))}
                            {graphData.map(assessAllocation)}
                          </Pie>
                          <Legend margin={{ top: -500, }} formatter={renderColorfulLegendText} className="legend-text" iconSize={10} width={300} height={50} layout='vertical' />
                          <Tooltip />
                        </PieChart>
                      </div>

                      {/* End Sector breakdown Chart */}
                    </div>



                    <div class="DailyPricing__SourceWrapper-sc-62f3gi-4 hfRiYK"><br />
                      <p className="mt-2 i">Monthly data as at: {PRTUDate}.
                        All information also available to download <a href={config.apiPath + "/sitepdfs/aim_portfolio.pdf"} target="_blank">here</a>
                        <br /></p>
                    </div>
                  </div>

                  <div class="tab-pane fade" id="one" role="tabpanel">
                    <div class="row">

                      <div class="col-sm-12">
                        <div role="tabpanel" aria-hidden="false" class="fade tab-pane active show">

                          <div class="row chart-row">
                            <div class="col-md-12 chart-block" >
                              <p class="lse_redirect">&nbsp;</p>
                              <LineChart
                                width={700}
                                height={260}
                                data={InceptionArrayState}
                                margin={{
                                  top: 5,
                                  right: 30,
                                  left: -20,
                                  bottom: 5
                                }}
                              >
                                <CartesianGrid horizontal="true" vertical="" strokeDasharray=" " />
                                <XAxis dataKey="date" />
                                <YAxis tickFormatter={(tick) => {
                                  return `${tick}%`;
                                }}
                                />
                                {/* <Tooltip /> */}
                                {/* <Legend /> */}
                                <Line
                                  type="monotone"
                                  dataKey="value"
                                  stroke="#1a2352"
                                  dot={false}
                                  activeDot={{ r: 4 }}
                                />

                              </LineChart>
                              <p class="lse_redirect1"><span class="span_color"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>&nbsp;&nbsp; EPIC AIM IHT Portfolio</p>
                            </div>
                          </div>

                          <div class="mb-2 row cum-row">
                            <div class="col-md-12  table-responsive" >
                              <table class="table  CumulativePerformance__Table-sc-51pab9-0 hRUkzz hRUkzz_dfm_new">
                                <tbody>
                                  <tr class="CumulativePerformance__TopRow-sc-51pab9-1 dwdfBh">

                                    {cummulatovePerfData.map(renderCummulativePerformanceNames)}

                                  </tr>
                                  <tr class="CumulativePerformance__BottomRow-sc-51pab9-2 eeFpGK">

                                    {cummulatovePerfData.map(renderCummulativePerformanceValue)}

                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>

                          <div class="row cum-row">
                            <div class="col-md-12  table-responsive" >
                              <table class=" table  CumulativePerformance__Table-sc-51pab9-0 hRUkzz hRUkzz_dfm_new">
                                <tbody>
                                  <tr class="CumulativePerformance__TopRow-sc-51pab9-1 dwdfBh">

                                    {TwelveMperfAGBPState.map(renderCummulativePerformanceNames)}

                                  </tr>
                                  <tr class="CumulativePerformance__BottomRow-sc-51pab9-2 eeFpGK">

                                    {TwelveMperfAGBPState.map(renderCummulativePerformanceValue)}

                                  </tr>



                                </tbody>
                              </table>
                            </div>
                          </div>


                          <div class="row table-growth-row remove_margin">

                          </div>





                          <div class="mb-2 row monthly-row">
                            <div class="col" >
                              <div class="MonthlyPerformance__Wrapper-sc-1n33bhd-0 cHAvbZ">

                              </div>
                            </div>
                          </div>
                          <div class="DailyPricing__SourceWrapper-sc-62f3gi-4 hfRiYK">
                            <p className="mt-2 i">Monthly data as at: {PRTUDate}.
                              All information also available to download <a href={config.apiPath + "/sitepdfs/aim_portfolio.pdf"} target="_blank" download>here </a>
                              <br /></p>
                          </div>
                        </div>

                      </div>


                    </div>
                  </div>
                  <div class="tab-pane fade" id="two" role="tabpanel">
                    <div class="row">
                      <div class="col-sm-12">
                        <div role="tabpanel" aria-hidden="false" class="fade tab-pane active show">
                          <div class="mb-2 row">
                            <div class="col-md-12" dangerouslySetInnerHTML={{ __html: productsCommentary }}></div>
                          </div>
                          <div class="DailyPricing__SourceWrapper-sc-62f3gi-4 hfRiYK">
                            <p className="mt-2 i">Monthly data as at: {PRTUDate}.
                              All information also available to download <a href={config.apiPath + "/sitepdfs/aim_portfolio.pdf"} target="_blank" download>here</a>
                              <br /></p>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="tab-pane fade" id="three" role="tabpanel">
                    <div class="row">
                      <div class="col-sm-12">
                        <div role="tabpanel" aria-hidden="false" class="fade tab-pane active show">
                          <div class="mb-3 row">
                            <div class="col  table-responsive" >
                              <table class="FundInformation__Table-sc-18irt95-0 cRUpgb">
                                <tbody class=" FundInformation__Body-sc-18irt95-1 hNmQXY">
                                  <tr class="FundInformation__Row-sc-18irt95-2 kzFInj">
                                    <th>Fund Information</th>
                                  </tr>
                                  {Fundinfoarray.map(renderFundinfo)}
                                  {CMSFundinfoarray.map(renderFundinfo)}
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col  table-responsive" >
                              <table class="table  Shares__Table-sc-1brks4f-0 hBbtmd">
                                <tbody class="Shares__Body-sc-1brks4f-1 hbWYKC">
                                  <tr class="Shares__Row-sc-1brks4f-2 hzpAKA">


                                    {ShareClassarray.map(renderShareClassNames)}

                                  </tr>
                                  <tr class="Shares__Row-sc-1brks4f-2 eoQrEv">

                                    {ShareClassarray.map(renderShareClassValue)}
                                  </tr>
                                  {CMSshareinfoarray.map(renderCMSshareinfo)}

                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div class="DailyPricing__SourceWrapper-sc-62f3gi-4 hfRiYK">
                            <p className="mt-2 i">Monthly data as at: {PRTUDate}.
                              All information also available to download <a href={config.apiPath + "/sitepdfs/aim_portfolio.pdf"} target="_blank" download>here </a>
                              <br /></p>
                          </div>
                        </div>

                      </div>

                    </div>
                  </div>
                  <div class="tab-pane fade" id="four" role="tabpanel">
                    <div class="row">
                      <div class="col-sm-12">

                        <div className="row ">


                          {KeyInveInfoState.length > 0 ? <div class="col-md-12"><h3><b>Key Investor Information</b></h3><br /></div> : ""}
                          {KeyInveInfoState.length > 0 ? KeyInveInfoState.map(renderLiteratureData) : ""}

                          <div class="col-sm-12">
                            <h4>Fact Sheet</h4>

                            <p class="pdf_download">
                              <a href={config.apiPath + "/sitepdfs/aim_portfolio.pdf"} target="_blank" download>AIM IHT Portfolio PDF
                                <br />
                              </a>
                            </p>
                          </div>
                          {LiteratureDataState.length > 0 ? <div class="col-md-12"><h3><b>Other Information</b></h3><br /></div> : ""}
                          {LiteratureDataState.length > 0 ? LiteratureDataState.map(renderLiteratureData) : ""}

                          {PressCoverageState.length > 0 ? <div class="col-md-12"><h3><b>Recent Updates</b></h3><br /></div> : ""}
                          {PressCoverageState.length > 0 ? PressCoverageState.map(renderLiteratureData) : ""}


                          {ApplicationsState.length > 0 ? <div class="col-md-12"><h3><b>Applications</b></h3><br /></div> : ""}
                          {ApplicationsState.length > 0 ? ApplicationsState.map(renderLiteratureData) : ""}

                          {ReportsState.length > 0 ? <div class="col-md-12"><h3><b>Reports</b></h3><br /></div> : ""}
                          {ReportsState.length > 0 ? ReportsState.map(renderLiteratureData) : ""}

                          {offerDocumentState.length > 0 ? <div class="col-md-12"><h3><b>Offering Documents</b></h3><br /></div> : ""}
                          {offerDocumentState.length > 0 ? offerDocumentState.map(renderLiteratureData) : ""}


                        </div>


                      </div>

                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>
        : <div className="center"><ReactBootstrap.Spinner animation="border" /></div>
      }
    </Fragment>
  );
}
export default EpicMultiAssetBalancedFunction;

